import { SearchTerm } from "./SearchTerm";

const ReasonCodeSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "arcDesc",
        translationKey: "name"
    }
];

export default ReasonCodeSearch;
